import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { RootState } from 'redux/store';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';

interface typesOfWalletInvoices {
    walletInvoicesList: any;
    loading: boolean;
    error: string | null;
    totalCount: number;
}
const initialState: typesOfWalletInvoices = {
    walletInvoicesList: [],
    loading: false,
    error: null,
    totalCount: 0,
};

export const fetchWalletInvoicesList = createAsyncThunkWrapper('walletInvoices/fetchWalletInvoicesList', async (_, { getState }) => {
    const state = getState() as RootState;
    const { pageNumber, pageSize } = state.app.table;
    const response: any = await client.get('/request/getRequestMoneyActivityPagination', {
        headers: {
            pageSize,
            pageNumber,
        },
    });
    if (response?.code === 200) {
        const { approved, pending, rejected, activity } = response || {};
        return { activity, totalCount: approved + pending + rejected };
    }
});

const walletInvoicesSlice = createSlice({
    name: 'walletInvoicesList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchWalletInvoicesList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchWalletInvoicesList.fulfilled, (state, action) => {
            state.loading = false;
            const payload = action?.payload;
            if (!payload) return;
            const { activity, totalCount } = payload || {};
            state.walletInvoicesList = activity || [];
            state.totalCount = totalCount;
        });
        builder.addCase(fetchWalletInvoicesList.rejected, (state) => {
            state.loading = false;
        });
    },
});

export default walletInvoicesSlice.reducer;
